import { api } from './client';

/**
 * Web-side half of the extension connect flow (docs/DESIGN_EXTENSION.md §3).
 * The extension opens this app with `?ext_challenge=<S256 code_challenge>`;
 * the manager presses "Подключить расширение", which mints a short-lived
 * one-time code bound to that challenge, and copies it into the side panel.
 */
export interface ExtensionAuthCode {
  code: string;
  expires_in: number;
}

export function startExtensionAuth(codeChallenge: string): Promise<ExtensionAuthCode> {
  return api.post<ExtensionAuthCode>('/api/v1/extension/auth/start', {
    code_challenge: codeChallenge,
    code_challenge_method: 'S256',
  });
}

export interface ConfirmChannelBody {
  linked_group_channel_id?: string | null;
}

export interface ConfirmedChannel {
  channel: {
    id: string;
    type: string;
    vk_user_id: number | null;
    title: string | null;
    status: string;
    confirmed: boolean;
    confirmed_at: string | null;
    linked_group: { id: string; title: string | null } | null;
  };
}

export function confirmChannel(id: string, body: ConfirmChannelBody): Promise<ConfirmedChannel> {
  return api.post<ConfirmedChannel>(`/api/v1/channels/${id}/confirm`, body);
}
